module.exports = __webpack_public_path__ + "img/home-bg6-4.e441fb9c.png";